
    angular.module('cvsApp').service('findProfilesService', ['networkService', 'xdrService', 'configManager',
    'findProfilesModel', 'cvsAppData', function (NS, XS, CM, TEM, CAD) {

        function findProfiles() {
            this.findProfiles = function (callBackSuccess, ofindProfiles) {
                var apikey = CAD.getApiKey();
                // $scope.patientData = CAD.getPatientList();
                var params = "&tokenID=" + ofindProfiles.tokenID ;
                var url = CM.getAGPAPIUrl('FIND_PROFILES');
                // var url = CVS.Config.AWS[cvsUtility.queryMap.env] + "dswebservices/check/findProfiles";
                // var url = CVS.Config.AWS[cvsUtility.queryMap.env] + "SPLAGPv1/utilityService/resolveProfileConflictBot/v1";
                
                
                console.log(CVS.Config);
                console.log(cvsUtility.queryMap.env);
                // var appConfigs = appConfig(config);
			    // var version = getVersion(serviceKey);
                //  var url = CM.getApiUrlWithApikey('FIND_PROFILES') + params;
                // var url = CM.getApiUrlWithApikeyAndAppName('FIND_PROFILES', "SPL") + params;
                function getVersion (serviceKey){
                    if(CVS.Config && CVS.Config.version && CVS.Config.version[serviceKey]){
                        return '&version='+CVS.Config.version[serviceKey];
                    }else{
                        return "&version=1.0";
                    }
                };

                if (url === "URL_ERROR") {

                } else {
                    var request = {
                        url: url,
                        header: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json'
                        },
                        data: requestBody(),
                        onSuccess: callBackSuccess
                    }
                    cvsUtility.commonServiceCode(url, "findProfiles", TEM, request, callBackSuccess, NS);
                }

            }
            var requestBody = function() {
                var reqObj = {
                    "resolveProfileConflictBotRequest": {
                        "header" : {
                        "serviceContext": { 
                             "appName": cvsUtility.queryMap.mobileAppStyle ? 'SPL_APP' : 'SPL_WEB', 
                             "lineOfBusiness": "Specialty", 
                             "channelName": "Web", 
                              "responseFormat": "JSON"
                            } ,
                        "securityContext":{
                              "apiKey": cvsUtility.queryMap.apikey,
                               "securityType": "apiKey" 
                            }
                         },
                       "details":{
                                    "hbsId": CAD.getSelectedPatient().patientIdentifier,
                                    "catsId":'',
                                    "digitalId":CAD.getSelectedPatient().digitalUserID,
                                    "sendToSPARCS":"YES",
                                    'requestingModule':"SUPER_USER"
                       }
                }
            }
            return reqObj;
        }  
    }

        return new findProfiles();
    }]);